import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE } from "../../apiConfig";

export default function SuperAdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const login = async () => {
    try {
      const res = await axios.post(`${API_BASE}/superAdminLogin.php`, {
        username,
        password,
      });

      if (res.data.status === "success") {
        sessionStorage.setItem("super_token", res.data.token);
        navigate("/superadmin");
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      alert("Login Failed");
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-11 col-md-5">
          <div className="card shadow border-0 rounded-4 p-4">
            <h3 className="fw-bold text-center mb-3">Super Admin Login 👑</h3>

            <input
              className="form-control form-control-lg mb-3"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />

            <input
              className="form-control form-control-lg mb-3"
              placeholder="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <button className="btn btn-dark btn-lg w-100" onClick={login}>
              Login
            </button>

            <small className="text-muted d-block mt-3 text-center">
              Default: superadmin / super123
            </small>
          </div>
        </div>
      </div>
    </div>
  );
}
